import styled from 'styled-components';

export const Spinner = styled.div`
  width: 4.125rem;
  height: 4.125rem;
  display: block;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);

  svg {
    path {
      stroke: #00AAE7;
    }
    transition-property: transform;
    animation-name: loading;
    animation-duration: 0.45s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    transition-timing-function: ease-in-out;


    @keyframes loading {
      0% {
        transform: rotate(0deg);
      }
      75% {
        transform: rotate(300deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
`;

export const SpinnerLoadingWrapper = styled.div`
  width: 100%;
  height: ${(props) => `${props.height}rem`};
  margin: auto;
  display: block;
  position: relative;

`;
